module.exports = __webpack_public_path__ + "img/arrow-down-right.20b0bea5.svg";